export const initialState = {
    autoLogoutPaused: false,
};
